<template>
  <div id="wrapper" :style="{ marginTop: TestMode ? '40px' : '0' }">
    <!-- Sidebar -->
    <sidebar-menu :toggled="sidebarToggled" />
    <!-- End of Sidebar -->
    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">
      <!-- Main Content -->
      <div id="content">
        <!-- Topbar -->
        <top-bar-menu @toggle-sidebar="toggleSidebar" />
        <!-- End of Topbar -->
        <slot />
      </div>
      <!-- End of Main Content -->
      <!-- Footer -->
      <footer-content />
      <!-- End of Footer -->
    </div>
    <!-- End of Content Wrapper -->
  </div>
</template>

<script>
import NavMenu from "@/components/NavMenu.vue";
import TopBarMenu from "@/components/TopBarMenu.vue";
import SidebarMenu from "@/components/SidebarMenu.vue";
import companyConfig from "@/company_config.json";

export default {
  components: {
    NavMenu,
    TopBarMenu,
    SidebarMenu,
  },
  data() {
    return {
      TestMode: companyConfig.TestMode,
      sidebarToggled: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.sidebarToggled = !this.sidebarToggled;
    },
  },
};
</script>

<style lang="scss" scoped>
#inspire {
  .v-application {
    background-color: #ffffe0;
  }

  #app {
    text-align: start;
  }

  .content {
    padding-top: 116.018px;
  }

  @media (max-width: 768px) {
    .content {
      padding-top: 35px;
      padding-left: 25px;
      padding-right: 25px;
    }
  }

  @media (min-width: 1000px) {
    .container--fluid {
      width: 980px;
    }
  }
}
</style>
